import { useLayoutEffect, useState } from 'react';
import { Dialog, makeStyles, useMediaQuery } from '@material-ui/core';
import useSocket from '../hooks/useSocket';
import { MessageType } from '../enums/MessageType';
import { useTheme } from '@material-ui/core/styles';
import { PaymentProviderType } from '../enums/PaymentProviderType';

const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.up('sm')]: {
      height: '60vh',
    },
  },
}));

declare const Dibs: any;

export const PaymentRedirectListener = ({
  guid,
  html,
  paymentId,
  paymentProviderType,
  onRedirectSuccess,
  onRedirectError,
  children,
}: {
  guid: string;
  html: string | null;
  paymentId: string | null; // Only used in Nets integration for now
  paymentProviderType: PaymentProviderType | null;
  onRedirectSuccess: () => void;
  onRedirectError: () => void;
  children: React.ReactNode;
}) => {
  const [jsInitialized, setJsInitialized] = useState(false);
  const [netsContainer, setNetsContainer] = useState<HTMLDivElement | null>(null);

  useSocket(
    'paymentEventHub',
    'PaymentEvent',
    (data) => {
      const success = data.type === MessageType.PaymentEvent && !!data.id && data.title === guid;
      if (success) {
        onRedirectSuccess();
      } else {
        onRedirectError();
      }
    },
    `?guid=${guid}`,
  );

  const theme = useTheme();
  const desktopMediaQuery = useMediaQuery(theme.breakpoints.up('sm'));
  const classes = useStyles();

  useLayoutEffect(() => {
    if (
      paymentProviderType === PaymentProviderType.Nets &&
      paymentId &&
      !jsInitialized &&
      !!netsContainer
    ) {
      setJsInitialized(true);
      const checkoutOptions = {
        checkoutKey: import.meta.env.VITE_NETS_EASY_CHECKOUT_KEY,
        paymentId: paymentId,
        containerId: 'nets-checkout-container',
      };
      const checkout = new Dibs.Checkout(checkoutOptions);

      // This event is not needed, just use the socket connection
      checkout.on('payment-completed', function () {
        checkout.cleanup();
      });
    }
  }, [paymentProviderType, paymentId, jsInitialized, netsContainer]);

  return (
    <>
      <Dialog
        open={!!html || !!paymentId}
        fullWidth
        maxWidth={'sm'}
        fullScreen={!desktopMediaQuery}
        classes={{
          paper: classes.paper,
        }}
      >
        {(() => {
          switch (paymentProviderType) {
            case PaymentProviderType.Nets:
              return (
                <div
                  id="nets-checkout-container"
                  ref={(el) => {
                    setNetsContainer(el);
                  }}
                />
              );
            case PaymentProviderType.Borgun:
            case PaymentProviderType.Valitor:
            case PaymentProviderType.Aur:
            default:
              return (
                <iframe srcDoc={html ?? undefined} frameBorder="0" style={{ height: '100%' }} />
              );
          }
        })()}
      </Dialog>
      {children}
    </>
  );
};
